import React, {useState, useRef, useCallback, useEffect} from "react";

import { ThriveIcon, IconLibrary } from 'thrive-components'

import { BuildPath } from "../../../helpers/Paths.ts";

import './CsvDropZone.scss';

export default function CsvDropzone({ file, onFileAccepted, onError }: any) {
    const [isDragging, setIsDragging] = useState(false);
    const [fileName, setFileName] = useState<string | null>(null);
    const inputRef = useRef(null);

    useEffect(() => {
        if (!file) {
            setFileName(null);
        }
    }, [file])

    const isCsv = (file:File) =>
        file &&
        (file.type === "text/csv" ||
            file.type === "application/vnd.ms-excel" ||
            file.name.toLowerCase().endsWith(".csv"));

    const handleFiles = useCallback(
        (fileList: FileList) => {
            const files = Array.from(fileList || []);

            if (files.length === 0) return;

            if (files.length > 1) {
                onError?.("Please drop only one file.");
                return;
            }

            const file = files[0];

            console.log(file);

            if (!isCsv(file)) {
                onError?.("Only .csv files are accepted.");
                return;
            }

            setFileName((file as any).name);
            onFileAccepted?.(file);
        },
        [onFileAccepted, onError]
    );

    const handleDrop = (e: React.DragEvent) => {
        e.preventDefault();
        setIsDragging(false);
        handleFiles(e.dataTransfer.files);
    };

    const handleDragOver = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleInputChange = (e: React.ChangeEvent) => {
        handleFiles((e.target as HTMLInputElement).files as FileList);
        // reset so selecting the same file again still fires onChange
        (e.target as HTMLInputElement).value = "";
    };

    const handleClick = () => {
        (inputRef.current as unknown as HTMLInputElement)?.click();
    };

    const clearFiles = () => {
        setFileName('');
        onFileAccepted?.(undefined);
    }

    return (
        <div
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            data-dragging={isDragging}
            className={`csv-dropzone ${file && ' has-file '} ${isDragging && ' is-dragging '}`}
        >
            <input
                ref={inputRef}
                type="file"
                accept=".csv,text/csv"
                onChange={handleInputChange}
                style={{ display: "none" }}
            />
            {fileName ? <>
                <div className="file-selected-button-wrapper">
                    <button onClick={handleClick} className={'upload-file-button'}>
                        <img className={'file-icon'} src={`${BuildPath()}/images/content-types/file_icon.svg`} alt={''} />
                        <span>{fileName}</span>
                    </button>
                    <button onClick={clearFiles} className={'remove-file-button'}>
                        <ThriveIcon iconName={IconLibrary.BIN} color={'var(--thriveCharcoal)'} sizeInPx={"14"}/>
                    </button>
                </div>
            </> : <button onClick={handleClick} className={'upload-file-button'}>
                <ThriveIcon iconName={IconLibrary.FILE_UPLOAD} color={'var(--thriveSky)'} sizeInPx={"14"}/>
                <span>Choose File</span>
            </button>}
        </div>
    );
}
